import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@infra/auth/auth.service';
import { BaseListagemComponent } from '@common/modules/base/base-listagem.component';
import { ExcelService } from '@shared/utils/excel.util';
import { Coluna } from '@components/table/table.component';
import { Acao } from '@components/filtros/filtros.component';
import { Campo } from '@components/form/form.component';
import { dateFormat } from '@shared/formatters';
import { FrotaContratadaModel } from '@data/contrato/models';
import { FrotaContratadaController } from '@modules/frota-contratada/controllers';
import { modal } from '@shared/alerts/modal/modal.alert';
import { VincularCondutorComponent } from '@modules/frota-contratada/components/vincular-condutor/vincular-condutor.component';
import { ContratoRepository } from '@data/contrato/contrato.repository';
import { AnexosVeiculoComponent } from '../../components/vincular-condutor/anexos/anexos-veiculo.component';

@Component({
  selector: 'app-frota-contratada',
  templateUrl: './frota-contratada.component.html',
  styleUrls: ['./frota-contratada.component.scss']
})
export class FrotaContratadaComponent extends BaseListagemComponent<FrotaContratadaModel>{
  filtroAtual: string = '';

  filtros: Campo[] = [
    {
      name: 'grupoContrato.numeroGrupoContrato',
      label: 'Contrato Master',
      type: 'text',
      icon: 'insert_drive_file',
      width: '20%',
      mask: '',
      validators: [],
    },
    {
      name: 'veiculo.placa',
      label: 'Placa',
      type: 'text',
      icon: 'directions_car',
      width: '14%',
      validators: [],
    },
    {
      name: 'classeId',
      label: 'Tipo Contrato',
      type: 'select',
      icon: 'receipt',
      width: '16%',
      selectOptions: {
        items: [
          { label: 'Contratos RAC', value: '1' },
          { label: 'Contratos Fleet', value: '2' },
          { label: 'Contratos CaaS', value: '3' },
        ],
      },
      validators: [],
    },
    {
      name: 'encerrado',
      label: 'Encerrado',
      type: 'select',
      icon: 'receipt',
      width: '16%',
      selectOptions: {
        items: [
          { label: 'Sim', value: 'S' },
          { label: 'Não', value: 'N' },
          { label: 'Todos', value: "S,N" },
        ],
      },
      validators: [],
    },
    {
      name: 'grupoContrato.contratoGrupoVeiculos.dataHoraEntrega || dataHoraInicio',
      label: 'Período Abertura',
      type: 'date-range',
      width: '25%',
      dateRangeOptions: {
        icon: 'prefix',
      },
      validators: [],
    },
    {
      name: 'grupoContrato.contratoGrupoVeiculos.dataHoraTermino || dataHoraTermino',
      label: 'Período Retorno',
      type: 'date-range',
      width: '25%',
      dateRangeOptions: {
        icon: 'prefix',
      },
      validators: [],
    },
  ];

  protected acoes: Acao[] = [
    {
      icon: 'save_alt',
      tooltip: 'Baixar Excel',
      action: this.baixarExcel.bind(this),
    },
  ];

  public colunas: Coluna[] = [
    { name: 'numeroContratoGrupo', label: 'Contrato Master' },
    { name: 'encerrado', label: 'Encerrado', format: (value: string) => {
      if (value === 'S') { 
        return 'Sim' 
      } else return 'Não'
    }},
    { name: 'tipoContrato', label: 'Tipo Contrato' },
    { name: 'placa', label: 'Placa' },
    { name: 'marca', label: 'Marca' },
    { name: 'modelo', label: 'Modelo', truncate: 15 },
    { name: 'anoFabricacao', label: 'Ano Fabricação' },
    { name: 'chassi', label: 'Chassi' },
    { name: 'renavam', label: 'Renavam' },
    { name: 'dataAbertura', label: 'Data Abertura', format: dateFormat },
    { name: 'dataRetorno', label: 'Data Retorno', format: dateFormat },
    { name: 'franquiaKm', label: 'Franquia KM' },
    // { name: 'situacaoVeiculo', label: 'Situação Veículo' },
    // { name: 'diasAlugado', label: 'Dias Alugado' },
    // { name: 'diasManutencao', label: 'Dias Manutenção' },
    { name: 'condutorPrincipal', label: 'Condutor' },
    { name: 'localVeiculo', label: 'Local Veículo' },
    { name: 'franquiaAcidente', label: 'Franquia Acidentes' },
    {
      name: 'acoes',
      label: 'Ações',
      acoes: [
        {
          label: (item) => item.condutorPrincipal ? 'Desvincular condutor' : 'Víncular condutor',
          icon: (item) => item.condutorPrincipal ? 'link_off' : 'link',
          action: (item) => item.condutorPrincipal ? this.desvincularCondutor(item) : this.vincularCondutor(item),
          disabled: !this.authService.hasPermission('frota', 'EDITAR')
        },
        {
          label: 'Anexos',
          icon: 'attach_file',
          action: this.anexarArquivos.bind(this),
        },
      ]
    }
  ];

  constructor(
    private frotaContratadaController: FrotaContratadaController,
    private dialog: MatDialog,
    public excelService: ExcelService,
    private authService: AuthService,
    private contratoRepository: ContratoRepository,
  ) {
    super('Frota Contratada - Portal do Cliente', frotaContratadaController);
  }

  public async baixarExcel() {
    this.frotaContratadaController.getPaginated({ page: 1, offset: 0, limit: 10000, search: this.filtroAtual }).subscribe((response) => {
      const header = this.colunas.map((c) => c.label).filter((c) => c !== 'Ações');

      const data = response.data.results.map((item) => {
        return {
          numeroContratoGrupo : item.numeroContratoGrupo,
          encerrado : item.encerrado === 'S' ? 'Sim' : 'Não',
          tipoContrato: item.tipoContrato,
          placa: item.placa,
          marca: item.marca,
          modelo: item.modelo,
          anoFabricacao: item.anoFabricacao,
          chassi: item.chassi,
          renavam: item.renavam,
          dataAbertura: dateFormat(item.dataAbertura),
          dataRetorno: dateFormat(item.dataRetorno),
          franquiaKm: item.franquiaKm,
          situacaoVeiculo: item.situacaoVeiculo,
          diasAlugado: item.diasAlugado,
          diasManutencao: item.diasManutencao,
          condutorPrincipal: item.condutorPrincipal,
          localVeiculo: item.localVeiculo,
          franquiaAcidente: item.franquiaAcidente,
        }
      });
  
      this.excelService.exportToFile(header, data, 'Frota Contratada');
    });
  }

  vincularCondutor(item: FrotaContratadaModel): void {
    this.dialog.open(VincularCondutorComponent, {
      width: '900px',
      data: item,
      disableClose: true,
    }).afterClosed().subscribe((result) => {
      if(result) {
        this.filtrar();
      
        modal.fire({
          title: 'Sucesso!',
          text: 'Condutor vinculado com sucesso!',
          icon: 'success',
          confirmButtonText: 'Continuar',
        });
      }
    });
  }

  desvincularCondutor(item: FrotaContratadaModel): void {
    modal.fire({
      title: 'Desvincular condutor',
      text: 'Deseja realmente desvincular o condutor?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    }).then((result) => {
      if (result.isConfirmed) {
        this.contratoRepository.desvincularCondutor(item.codigoContrato, item.codigoCondutorPrincipal).subscribe({
          next: () => {
            this.filtrar();

            modal.fire({
              title: 'Sucesso!',
              text: 'Condutor desvinculado com sucesso!',
              icon: 'success',
              confirmButtonText: 'Continuar',
            });
          }
        });
      }
    });
  }

  filtrarFrotaContratada(query: string) {
    this.filtroAtual = query
    this.filtrar(this.filtroAtual)
  }

    public anexarArquivos(frota: any) {
       this.dialog.open(AnexosVeiculoComponent, {
            width: '800px',
            height: '600px',
            data: { codigoVeiculo: frota.codigoVeiculo },
          });
    }

}
